import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { IGlobalStoreState } from '../../store';
import { PreQueue } from '../../components/PreQueue';
import { Routes } from '../../store/routes';
import { Queue } from './Queue';
import { AlertType } from '../../store/enums';
import { AppSettings } from '../../settings/appSettings';
import { ContactsPage, PaymentsInfoPage } from './static';

const WaitingRoom: React.FC<{
  isBlocked: boolean;
  queueEmail: string;
  position: number;
  sessionId: string | null;
}> = ({ position, isBlocked, queueEmail, sessionId }) => {
  const resultType = useSelector<IGlobalStoreState, string>((state) => state.resultInfo.type);
  const isError = resultType === AlertType.Error;

  if (isBlocked) {
    return (
      <Container>
        <Title>You are blocked</Title>
      </Container>
    );
  }

  return (
    <Route
      render={({ location }) => (
        <Switch location={location}>
          <Route key={`waiting-room-${location.key}`} exact path={Routes.WaitingRoom}>
            {!queueEmail ? <PreQueue /> : <Queue position={position} sessionId={sessionId} queueEmail={queueEmail} />}
          </Route>
          <Route exact path={Routes.Contacts} component={ContactsPage} />
          <Route exact path={Routes.PaymentsInfo} component={PaymentsInfoPage} />
        </Switch>
      )}
    />
  );
};

export default WaitingRoom;

const Title = styled.h1`
  font-size: 2rem;
  color: white;
  margin-bottom: 2rem;
  font-family: Intro, ${AppSettings.DEFAULT_FONTS};
  text-align: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  margin-top: auto;
  margin-bottom: auto;
  padding: 0 5%;
`;
